<template>
    <v-flex class="pagina-curso" xs12 fill-height>
        <header-app :simple="true"></header-app>
        <div class="contenido">
          <v-layout wrap justify-center align-center>
              <v-flex xs12 sm5 md5 class="animated fadeInDown">
                  <dialogos-app :dialogos="dialogos" tucan="0" :diagCenter="true"></dialogos-app>
              </v-flex>
          </v-layout>
          <v-layout wrap row justify-center align-center text-xs-center class="cont_page mt-10">
            <v-flex xs12 md5 class="cont-button">
              <button class="button-unidad hvr hvr-scale" @click="goToModulo()">
                <div class="cont-icono animated flipInY dura-1">
                  <img :src="require('@/assets/presentacion/unidad-'+unidadNumber+'.png')" alt="">
                </div>
                <div class="cont-name animated fadeInUp dura-1" :style="{'background':btnColors[unidadNumber-1]}">
                  <h3 class="t-first" :class="{'text-white':unidadNumber == 4}">Unidade {{this.unidadNumber}}</h3>
                </div>
              </button>
            </v-flex>
          </v-layout>
        </div>
    </v-flex>
</template>
<script>
import nextConditions from "../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Bem-vindo à <strong> Unidade 1.</strong>'
      ],
      btnColors:['#65B8FF','#2199FF','#0077DC','#005297'],
      iconActive: [true,false,false,false],
      unidadNumber: 1,
    }
  },
  methods: {
    goToModulo(){
      this.$router.push('/unidad'+this.unidadNumber+'/0')
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../sass/globals';
.pagina-curso {
    background-image: url("../assets/fondo/Hoja_Izquierda_Optima.svg");
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: 180px;
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    .contenido {
        max-width: 100%;
        width: 1100px;
        margin: auto;
        position: relative;
        overflow: hidden;
        padding: 10px;
        min-height: calc(100vh - 60px);
        margin-top: 50px;
        padding-bottom: 2vh;
    }
}
.mt-10{
  margin-top: 10vh;
}
.button-unidad{
  text-align: center;
  margin: 0 auto;
  margin-bottom: 10px;
  div{
    display: flex;
    justify-content: center;
    align-content: center;
    text-align: center;
  }
  .cont-icono{
    width: 140px;
    height: 140px;
    border-radius: 50%;
    margin: 0 auto;
    overflow: hidden;
    img{
       width: 100%;
    }
    @media screen and (max-width: 300px){
      width: 120px;
      height: 120px;
    }
  }
  .cont-name{
    padding: 10px 35px;
    border-radius: 24px;
    @media screen and (max-width: 300px){
       padding: 5px 25px;
    }
  }
}
.t-first{
   font-family:Poppins-Bold;
   font-size: 30px;
   margin: 0;
   padding: 0;
    @media screen and (max-width: 300px){
        font-size: 25px;
    }
}
.text-white{
  color: #FFF;
}
</style>
